<template>
    <ul class="legend-panel" :class="{ 'legend-panel--compact': compact }">
        <li
            v-for="item in items"
            :key="item.key"
            class="legend-panel-item"
            :class="{
                'legend-panel-item--hidden': item.hidden && !item.isSelectAll && !item.isTop5,
                'legend-panel-item--top5': item.isTop5,
                'legend-panel-item--top5-active': item.isTop5 && item.active,
            }"
            role="button"
            tabindex="0"
            :title="itemTitle(item)"
            @click="onToggle(item.key)"
            @keydown.enter.prevent="onToggle(item.key)"
            @keydown.space.prevent="onToggle(item.key)"
        >
            <input
                v-if="item.isSelectAll"
                type="checkbox"
                class="legend-check"
                :checked="item.checked"
                tabindex="-1"
                @click.stop
                @change="onToggle(item.key)"
            />
            <span
                v-else-if="item.isTop5"
                class="legend-top5-label"
            >{{ item.label }}</span>
            <span
                v-else
                class="legend-mark"
                :class="{
                    'legend-mark--dashed': item.style === 'dashed',
                    'legend-mark--dotted': item.style === 'dotted',
                }"
                :style="markStyle(item)"
            />
            <span v-if="!item.isTop5" class="legend-label">{{ item.label }}</span>
        </li>
    </ul>
</template>

<script setup>
defineProps({
    items: {
        type: Array,
        default: () => [],
    },
    compact: { type: Boolean, default: false },
})

const emit = defineEmits(['toggle'])

function onToggle(key) {
    emit('toggle', key)
}

function itemTitle(item) {
    if (item.isSelectAll) {
        return item.checked ? 'Скрыть все серии' : 'Показать все серии'
    }
    if (item.isTop5) {
        return item.active ? 'Показать все серии' : 'Оставить только топ-5'
    }
    if (item.hidden) return 'Показать'
    return 'Скрыть'
}

function markStyle(item) {
    if (item.hidden) {
        return {
            background: 'transparent',
            borderColor: '#c0c0c0',
            opacity: 0.45,
        }
    }
    if (item.style === 'dashed' || item.style === 'dotted') {
        return { background: 'transparent', borderColor: item.color || '#B4B2A9' }
    }
    return { background: item.color, borderColor: item.color }
}
</script>

<style scoped>
.legend-panel {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.legend-panel--compact {
    flex-flow: row wrap;
    flex-direction: row;
    gap: 6px;
    max-width: 100%;
    align-items: center;
}

.legend-panel-item {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 4px 6px;
    border-radius: 6px;
    font-size: 11.5px;
    color: #23282C;
    cursor: pointer;
    user-select: none;
    transition: opacity 0.15s ease, background 0.15s ease, border-color 0.12s ease;
}

.legend-panel--compact .legend-panel-item {
    padding: 3px 6px;
    font-size: 10.5px;
}

.legend-panel-item:hover {
    background: #f0f0f0;
}

.legend-panel-item--hidden {
    opacity: 0.38;
}

.legend-panel-item--hidden .legend-label {
    text-decoration: line-through;
    text-decoration-color: rgba(35, 40, 44, 0.28);
}

.legend-panel-item--top5 {
    border: 1px solid #e0e0e0;
    background: white;
    font-weight: 600;
}

.legend-panel-item--top5-active {
    background: #23282C;
    border-color: #23282C;
    color: white;
}

.legend-panel-item--top5-active .legend-top5-label {
    color: white;
}

.legend-top5-label {
    line-height: 1.25;
}

.legend-check {
    width: 14px;
    height: 14px;
    margin: 0;
    flex-shrink: 0;
    accent-color: #23282C;
    cursor: pointer;
}

.legend-mark {
    width: 14px;
    height: 3px;
    border-radius: 1px;
    flex-shrink: 0;
}

.legend-mark--dashed {
    border: 1px dashed;
    height: 0;
    background: transparent !important;
}

.legend-mark--dotted {
    border: 1px dotted;
    height: 0;
    background: transparent !important;
}

.legend-label {
    line-height: 1.25;
}
</style>
